import { Link } from "react-router-dom";
import { LucideIcon } from "lucide-react";

interface CategoryCardProps {
  icon: LucideIcon;
  title: string;
  count: number;
  slug: string;
  color: "tech" | "sales" | "admin" | "health" | "education" | "logistics";
}

const colorClasses = {
  tech: "bg-category-tech/10 text-category-tech hover:bg-category-tech hover:text-white",
  sales: "bg-category-sales/10 text-category-sales hover:bg-category-sales hover:text-white",
  admin: "bg-category-admin/10 text-category-admin hover:bg-category-admin hover:text-white",
  health: "bg-category-health/10 text-category-health hover:bg-category-health hover:text-white",
  education: "bg-category-education/10 text-category-education hover:bg-category-education hover:text-white",
  logistics: "bg-category-logistics/10 text-category-logistics hover:bg-category-logistics hover:text-white",
};

export function CategoryCard({ icon: Icon, title, count, slug, color }: CategoryCardProps) {
  return (
    <Link
      to={`/vagas?categoria=${slug}`}
      className={`group flex flex-col items-center gap-3 p-6 rounded-xl transition-all duration-300 ${colorClasses[color]} card-hover`}
    >
      <div className="h-14 w-14 rounded-xl flex items-center justify-center bg-current/10 group-hover:bg-white/20 transition-colors">
        <Icon className="h-7 w-7" />
      </div>
      <h3 className="font-display font-semibold text-center">{title}</h3>
      <p className="text-sm opacity-80">{count} vagas</p>
    </Link>
  );
}
